import React, { memo, useCallback, useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import styles from './WpTurnStop.module.less';

import { logging } from '../../actions/log';
import { PCStoreJsBridge } from '../../nativeapi';
import { updateShowWpTurnStop } from '../../actions/wallpaper';
import Toast from '../../components/Toast/Toast';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
const selectWallpaper = createSelector(
  state => state.wallpaper,
  wallpaper => wallpaper,
);

export default memo(() => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const { wpShowTurnStop } = useSelector(selectWallpaper);

  useEffect(() => {
    loggingFunc('Wallpaper', 'P_Wallpaper_LoopStop');
    localStorage.setItem('Wp_Switch_Turn_Show', +new Date());
  }, []);

  const loggingFunc = useCallback(
    (category, action) => {
      dispatch(
        logging({
          category: category || 'Wallpaper',
          action: action || 'Wallpaper_LoopStop',
          label: '',
          param2: {
            source: logInfoData?.source,
            source_p: logInfoData?.source_p,
            source_pp: logInfoData?.source_pp,
            wpType: wpShowTurnStop?.wpType || 1, // 1: 单张壁纸，2：壁纸包 3: 仅仅订阅
          },
        }),
      );
    },
    [logInfoData, wpShowTurnStop],
  );

  const handleDialogClose = useCallback(
    flag => {
      if (flag) {
        // 因为变态的需求，需要先弹出选择是否关闭轮播弹框，但是因为后面又可能有购买弹框弹出，所以点击确认先不关闭轮播
        // let switchTurn = {};
        // if (window?.external?.get_wallpaper_carousel_switch_info) {
        //   switchTurn = JSON.parse(window.external.get_wallpaper_carousel_switch_info() || '{}');
        // }
        // // 去关闭轮播
        // PCStoreJsBridge.switchWpOpenTurn({
        //   switch: 'off',
        //   duration: switchTurn?.duration || 5,
        // }).then(res => {
        //   if (res) {
        //     if (
        //       window.PCStore_WpMine_TurnUpdate &&
        //       typeof window.PCStore_WpMine_TurnUpdate === 'function'
        //     ) {
        //       setTimeout(() => {
        //         window.PCStore_WpMine_TurnUpdate();
        //       }, 100);
        //     }
        //     Toast.success({
        //       content: '关闭壁纸轮播成功！',
        //     });
        //     dispatch(
        //       logging({
        //         category: 'Wallpaper',
        //         action: 'R_Wallpaper_Loop_Stop',
        //         label: '',
        //         param2: {
        //           source: logInfoData?.source,
        //           source_p: logInfoData?.source_p,
        //           source_pp: logInfoData?.source_pp,
        //           Looptype: 2,
        //         },
        //       }),
        //     );
        //   }
        // });
        // 回调函数
        if (
          wpShowTurnStop?.callbackTurnStop &&
          typeof wpShowTurnStop?.callbackTurnStop === 'function'
        ) {
          setTimeout(() => {
            wpShowTurnStop.callbackTurnStop(true);
          }, 50);
        }
      }
      setTimeout(() => {
        dispatch(
          updateShowWpTurnStop({
            show: false,
          }),
        );
      }, 100);
    },
    [wpShowTurnStop],
  );

  return (
    <div className={styles.dialog_box}>
      <div className={styles.dialog_cont}>
        <div className="dialog_header">
          <div className="dialog_header_text">温馨提示</div>
          <div
            className="dialog_header_close iconfont icon-opt_close"
            onClick={() => {
              handleDialogClose();
            }}
          ></div>
        </div>
        <div className="dialog_content">
          <div className={'dialog_content_text'}>已开启壁纸轮播，设置壁纸将暂停轮播。</div>
          <div className="dialog_opt">
            <div
              className={'dialog_btn_cancle'}
              onClick={() => {
                handleDialogClose();
              }}
            >
              继续轮播
            </div>
            <div
              className={'dialog_btn_sure'}
              onClick={() => {
                handleDialogClose(true);
              }}
            >
              设为壁纸
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});
